// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_UTCTime from "../Data.UTCTime/index.js";
import * as Data_UUID from "../Data.UUID/index.js";
import * as Data_Value from "../Data.Value/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Backstage_Types_Id from "../Restaumatic.Backstage.Types.Id/index.js";
import * as Restaumatic_Menu_V2_Types_Modifier from "../Restaumatic.Menu.V2.Types.Modifier/index.js";
import * as Restaumatic_Menu_V2_Types_Taxes from "../Restaumatic.Menu.V2.Types.Taxes/index.js";
import * as Restaumatic_ROS_Types_TerminalId from "../Restaumatic.ROS.Types.TerminalId/index.js";
import * as Restaumatic_Staff_Types_Id from "../Restaumatic.Staff.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var PaymentDeclined = /* #__PURE__ */ (function () {
    function PaymentDeclined() {

    };
    PaymentDeclined.value = new PaymentDeclined();
    return PaymentDeclined;
})();
var PaymentTimeout = /* #__PURE__ */ (function () {
    function PaymentTimeout() {

    };
    PaymentTimeout.value = new PaymentTimeout();
    return PaymentTimeout;
})();
var PaymentAfterRestaurantClosed = /* #__PURE__ */ (function () {
    function PaymentAfterRestaurantClosed() {

    };
    PaymentAfterRestaurantClosed.value = new PaymentAfterRestaurantClosed();
    return PaymentAfterRestaurantClosed;
})();
var ConfirmationTimeout = /* #__PURE__ */ (function () {
    function ConfirmationTimeout() {

    };
    ConfirmationTimeout.value = new ConfirmationTimeout();
    return ConfirmationTimeout;
})();
var Invalidated = /* #__PURE__ */ (function () {
    function Invalidated() {

    };
    Invalidated.value = new Invalidated();
    return Invalidated;
})();
var SideInfo = function (x) {
    return x;
};
var ShortOrderId = function (x) {
    return x;
};
var Dish = /* #__PURE__ */ (function () {
    function Dish() {

    };
    Dish.value = new Dish();
    return Dish;
})();
var Drink = /* #__PURE__ */ (function () {
    function Drink() {

    };
    Drink.value = new Drink();
    return Drink;
})();
var Pizza = /* #__PURE__ */ (function () {
    function Pizza() {

    };
    Pizza.value = new Pizza();
    return Pizza;
})();
var Promotion = /* #__PURE__ */ (function () {
    function Promotion() {

    };
    Promotion.value = new Promotion();
    return Promotion;
})();
var External = /* #__PURE__ */ (function () {
    function External() {

    };
    External.value = new External();
    return External;
})();
var PizzaPartDescription = function (x) {
    return x;
};
var ParameterDescription = function (x) {
    return x;
};
var OrderUUID = function (x) {
    return x;
};
var OrderDraft = function (x) {
    return x;
};
var ModifierItemDescription = function (x) {
    return x;
};
var ModifierDescription = function (x) {
    return x;
};
var ProductPartDescription = function (x) {
    return x;
};
var Main = /* #__PURE__ */ (function () {
    function Main() {

    };
    Main.value = new Main();
    return Main;
})();
var Side = /* #__PURE__ */ (function () {
    function Side() {

    };
    Side.value = new Side();
    return Side;
})();
var Freebie = /* #__PURE__ */ (function () {
    function Freebie() {

    };
    Freebie.value = new Freebie();
    return Freebie;
})();
var Info = /* #__PURE__ */ (function () {
    function Info() {

    };
    Info.value = new Info();
    return Info;
})();
var DishDescription = /* #__PURE__ */ (function () {
    function DishDescription(value0) {
        this.value0 = value0;
    };
    DishDescription.create = function (value0) {
        return new DishDescription(value0);
    };
    return DishDescription;
})();
var SideDescription = /* #__PURE__ */ (function () {
    function SideDescription(value0) {
        this.value0 = value0;
    };
    SideDescription.create = function (value0) {
        return new SideDescription(value0);
    };
    return SideDescription;
})();
var DrinkDescription = /* #__PURE__ */ (function () {
    function DrinkDescription(value0) {
        this.value0 = value0;
    };
    DrinkDescription.create = function (value0) {
        return new DrinkDescription(value0);
    };
    return DrinkDescription;
})();
var PizzaDescription = /* #__PURE__ */ (function () {
    function PizzaDescription(value0) {
        this.value0 = value0;
    };
    PizzaDescription.create = function (value0) {
        return new PizzaDescription(value0);
    };
    return PizzaDescription;
})();
var FreebieDescription = /* #__PURE__ */ (function () {
    function FreebieDescription(value0) {
        this.value0 = value0;
    };
    FreebieDescription.create = function (value0) {
        return new FreebieDescription(value0);
    };
    return FreebieDescription;
})();
var TextDescription = /* #__PURE__ */ (function () {
    function TextDescription(value0) {
        this.value0 = value0;
    };
    TextDescription.create = function (value0) {
        return new TextDescription(value0);
    };
    return TextDescription;
})();
var SplitPizzaDescription = /* #__PURE__ */ (function () {
    function SplitPizzaDescription(value0) {
        this.value0 = value0;
    };
    SplitPizzaDescription.create = function (value0) {
        return new SplitPizzaDescription(value0);
    };
    return SplitPizzaDescription;
})();
var ProductDescription = /* #__PURE__ */ (function () {
    function ProductDescription(value0) {
        this.value0 = value0;
    };
    ProductDescription.create = function (value0) {
        return new ProductDescription(value0);
    };
    return ProductDescription;
})();
var NoDescription = /* #__PURE__ */ (function () {
    function NoDescription() {

    };
    NoDescription.value = new NoDescription();
    return NoDescription;
})();
var IntegrationId = function (x) {
    return x;
};
var Customer = function (x) {
    return x;
};
var CorrectedTotal = function (x) {
    return x;
};
var Accepted = /* #__PURE__ */ (function () {
    function Accepted(value0) {
        this.value0 = value0;
    };
    Accepted.create = function (value0) {
        return new Accepted(value0);
    };
    return Accepted;
})();
var Rejected = /* #__PURE__ */ (function () {
    function Rejected() {

    };
    Rejected.value = new Rejected();
    return Rejected;
})();
var AutoCancel = /* #__PURE__ */ (function () {
    function AutoCancel() {

    };
    AutoCancel.value = new AutoCancel();
    return AutoCancel;
})();
var PR = /* #__PURE__ */ (function () {
    function PR(value0) {
        this.value0 = value0;
    };
    PR.create = function (value0) {
        return new PR(value0);
    };
    return PR;
})();
var ROS = /* #__PURE__ */ (function () {
    function ROS(value0) {
        this.value0 = value0;
    };
    ROS.create = function (value0) {
        return new ROS(value0);
    };
    return ROS;
})();
var Email = /* #__PURE__ */ (function () {
    function Email() {

    };
    Email.value = new Email();
    return Email;
})();
var CallCenter = /* #__PURE__ */ (function () {
    function CallCenter(value0) {
        this.value0 = value0;
    };
    CallCenter.create = function (value0) {
        return new CallCenter(value0);
    };
    return CallCenter;
})();
var Printer = /* #__PURE__ */ (function () {
    function Printer() {

    };
    Printer.value = new Printer();
    return Printer;
})();
var Pendolino = /* #__PURE__ */ (function () {
    function Pendolino() {

    };
    Pendolino.value = new Pendolino();
    return Pendolino;
})();
var System = /* #__PURE__ */ (function () {
    function System(value0) {
        this.value0 = value0;
    };
    System.create = function (value0) {
        return new System(value0);
    };
    return System;
})();
var APIIntegration = /* #__PURE__ */ (function () {
    function APIIntegration(value0) {
        this.value0 = value0;
    };
    APIIntegration.create = function (value0) {
        return new APIIntegration(value0);
    };
    return APIIntegration;
})();
var PosBistro = /* #__PURE__ */ (function () {
    function PosBistro() {

    };
    PosBistro.value = new PosBistro();
    return PosBistro;
})();
var AutoCallCenter = /* #__PURE__ */ (function () {
    function AutoCallCenter() {

    };
    AutoCallCenter.value = new AutoCallCenter();
    return AutoCallCenter;
})();
var Portal = /* #__PURE__ */ (function () {
    function Portal() {

    };
    Portal.value = new Portal();
    return Portal;
})();
var Unknown = /* #__PURE__ */ (function () {
    function Unknown() {

    };
    Unknown.value = new Unknown();
    return Unknown;
})();
var Confirmation = function (x) {
    return x;
};
var eqSystemConfirmationStatu = {
    eq: function (x) {
        return function (y) {
            if (x instanceof PaymentDeclined && y instanceof PaymentDeclined) {
                return true;
            };
            if (x instanceof PaymentTimeout && y instanceof PaymentTimeout) {
                return true;
            };
            if (x instanceof PaymentAfterRestaurantClosed && y instanceof PaymentAfterRestaurantClosed) {
                return true;
            };
            if (x instanceof ConfirmationTimeout && y instanceof ConfirmationTimeout) {
                return true;
            };
            if (x instanceof Invalidated && y instanceof Invalidated) {
                return true;
            };
            return false;
        };
    }
};
var eqSideInfo = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.price)(y.price) && x.side === y.side && x.sideGroup === y.sideGroup;
        };
    }
};
var eqShortOrderId = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var eqProductType = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Dish && y instanceof Dish) {
                return true;
            };
            if (x instanceof Drink && y instanceof Drink) {
                return true;
            };
            if (x instanceof Pizza && y instanceof Pizza) {
                return true;
            };
            if (x instanceof Promotion && y instanceof Promotion) {
                return true;
            };
            if (x instanceof External && y instanceof External) {
                return true;
            };
            return false;
        };
    }
};
var eqPizzaPartDescription = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqString))(x.addedToppings)(y.addedToppings) && x.basePizza === y.basePizza && Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqString))(x.includedToppings)(y.includedToppings) && Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqString))(x.removedToppings)(y.removedToppings);
        };
    }
};
var eqParameterDescription = {
    eq: function (x) {
        return function (y) {
            return x.choice === y.choice && x.parameter === y.parameter;
        };
    }
};
var eqOrderUUID = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_UUID.eqUUID)(x)(y);
        };
    }
};
var eqOrderDraft = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Value.eqValue)(x)(y);
        };
    }
};
var eqModifierItemDescription = {
    eq: function (x) {
        return function (y) {
            return x.modifierItem === y.modifierItem && x.quantity === y.quantity && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.value)(y.value);
        };
    }
};
var eqModifierDescription = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Eq.eqArray(eqModifierItemDescription))(x.addedItems)(y.addedItems) && Data_Eq.eq(Data_Eq.eqArray(eqModifierItemDescription))(x.includedItems)(y.includedItems) && x.modifier === y.modifier && Data_Eq.eq(Data_Eq.eqArray(eqModifierItemDescription))(x.removedItems)(y.removedItems) && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.value)(y.value) && Data_Eq.eq(Restaumatic_Menu_V2_Types_Modifier.eqModifierVatRate)(x.vatRate)(y.vatRate);
        };
    }
};
var eqProductPartDescription = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.category)(y.category) && Data_Eq.eq(Data_Eq.eqArray(eqModifierDescription))(x.modifiers)(y.modifiers) && Data_Eq.eq(Data_Eq.eqArray(eqParameterDescription))(x.parameters)(y.parameters) && x.product === y.product && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.value)(y.value) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate))(x.vatRate)(y.vatRate);
        };
    }
};
var eqItemRole = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Main && y instanceof Main) {
                return true;
            };
            if (x instanceof Side && y instanceof Side) {
                return true;
            };
            if (x instanceof Freebie && y instanceof Freebie) {
                return true;
            };
            if (x instanceof Info && y instanceof Info) {
                return true;
            };
            return false;
        };
    }
};
var eqItemDescription = {
    eq: function (x) {
        return function (y) {
            if (x instanceof DishDescription && y instanceof DishDescription) {
                return Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.value0.basePrice)(y.value0.basePrice) && x.value0.dishGroup === y.value0.dishGroup && Data_Eq.eq(Data_Eq.eqArray(eqSideInfo))(x.value0.sides)(y.value0.sides) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate))(x.value0.vatRate)(y.value0.vatRate);
            };
            if (x instanceof SideDescription && y instanceof SideDescription) {
                return x.value0.sideGroup === y.value0.sideGroup;
            };
            if (x instanceof DrinkDescription && y instanceof DrinkDescription) {
                return x.value0.drinkSize === y.value0.drinkSize && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate))(x.value0.vatRate)(y.value0.vatRate);
            };
            if (x instanceof PizzaDescription && y instanceof PizzaDescription) {
                return Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqString))(x.value0.addedToppings)(y.value0.addedToppings) && Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqString))(x.value0.includedToppings)(y.value0.includedToppings) && x.value0.panType === y.value0.panType && x.value0.pizzaSize === y.value0.pizzaSize && Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqString))(x.value0.removedToppings)(y.value0.removedToppings) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate))(x.value0.vatRate)(y.value0.vatRate);
            };
            if (x instanceof FreebieDescription && y instanceof FreebieDescription) {
                return x.value0.freebie === y.value0.freebie && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate))(x.value0.vatRate)(y.value0.vatRate);
            };
            if (x instanceof TextDescription && y instanceof TextDescription) {
                return x.value0.description === y.value0.description && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate))(x.value0.vatRate)(y.value0.vatRate);
            };
            if (x instanceof SplitPizzaDescription && y instanceof SplitPizzaDescription) {
                return x.value0.panType === y.value0.panType && Data_Eq.eq(Data_Eq.eqArray(eqPizzaPartDescription))(x.value0.parts)(y.value0.parts) && x.value0.pizzaSize === y.value0.pizzaSize && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate))(x.value0.vatRate)(y.value0.vatRate);
            };
            if (x instanceof ProductDescription && y instanceof ProductDescription) {
                return Data_Eq.eq(Data_Eq.eqArray(eqModifierDescription))(x.value0.modifiers)(y.value0.modifiers) && Data_Eq.eq(Data_Eq.eqArray(eqParameterDescription))(x.value0.parameters)(y.value0.parameters) && Data_Eq.eq(Data_Eq.eqArray(eqProductPartDescription))(x.value0.productParts)(y.value0.productParts) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate))(x.value0.vatRate)(y.value0.vatRate);
            };
            if (x instanceof NoDescription && y instanceof NoDescription) {
                return true;
            };
            return false;
        };
    }
};
var eqIntegrationId = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var eqCustomer = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.email)(y.email) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.name)(y.name) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.originalPhone)(y.originalPhone) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.phone)(y.phone);
        };
    }
};
var eqCorrectedTotal = {
    eq: function (x) {
        return function (y) {
            return x.reason === y.reason && Data_Eq.eq(Data_Money_Rounded.eqMoney)(x.total)(y.total);
        };
    }
};
var eqConfirmationStatus = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Accepted && y instanceof Accepted) {
                return Data_Eq.eq(Data_UTCTime.eqUTCTime)(x.value0.deliveryTime)(y.value0.deliveryTime);
            };
            if (x instanceof Rejected && y instanceof Rejected) {
                return true;
            };
            return false;
        };
    }
};
var eqConfirmationSource = {
    eq: function (x) {
        return function (y) {
            if (x instanceof AutoCancel && y instanceof AutoCancel) {
                return true;
            };
            if (x instanceof PR && y instanceof PR) {
                return Data_Eq.eq(Restaumatic_Staff_Types_Id.eqStaffId)(x.value0.staffId)(y.value0.staffId) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.value0.staffName)(y.value0.staffName);
            };
            if (x instanceof ROS && y instanceof ROS) {
                return Data_Eq.eq(Restaumatic_Staff_Types_Id.eqStaffId)(x.value0.staffId)(y.value0.staffId) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.value0.staffName)(y.value0.staffName) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_ROS_Types_TerminalId.eqTerminalId))(x.value0.terminalId)(y.value0.terminalId);
            };
            if (x instanceof Email && y instanceof Email) {
                return true;
            };
            if (x instanceof CallCenter && y instanceof CallCenter) {
                return Data_Eq.eq(Restaumatic_Backstage_Types_Id.eqAdminUserId)(x.value0.adminUserId)(y.value0.adminUserId);
            };
            if (x instanceof Printer && y instanceof Printer) {
                return true;
            };
            if (x instanceof Pendolino && y instanceof Pendolino) {
                return true;
            };
            if (x instanceof System && y instanceof System) {
                return Data_Eq.eq(eqSystemConfirmationStatu)(x.value0.status)(y.value0.status);
            };
            if (x instanceof APIIntegration && y instanceof APIIntegration) {
                return Data_Eq.eq(eqIntegrationId)(x.value0.integration)(y.value0.integration);
            };
            if (x instanceof PosBistro && y instanceof PosBistro) {
                return true;
            };
            if (x instanceof AutoCallCenter && y instanceof AutoCallCenter) {
                return true;
            };
            if (x instanceof Portal && y instanceof Portal) {
                return true;
            };
            if (x instanceof Unknown && y instanceof Unknown) {
                return true;
            };
            return false;
        };
    }
};
var eqConfirmation = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_UTCTime.eqUTCTime)(x.confirmedAt)(y.confirmedAt) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString))(x.message)(y.message) && Data_Eq.eq(eqConfirmationSource)(x.source)(y.source) && Data_Eq.eq(eqConfirmationStatus)(x.status)(y.status);
        };
    }
};
var newtypeSideInfo = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeShortOrderId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeProductPartDescription = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypePizzaPartDescription = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeParameterDescription = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeOrderUUID = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeOrderDraft = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeModifierItemDescription = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeModifierDescription = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeIntegrationId = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCustomer = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCorrectedTotal = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeConfirmation = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldSideInfo = function (dictHasField) {
    return dictHasField;
};
var hasFieldProductPartDescription = function (dictHasField) {
    return dictHasField;
};
var hasFieldPizzaPartDescription = function (dictHasField) {
    return dictHasField;
};
var hasFieldParameterDescription = function (dictHasField) {
    return dictHasField;
};
var hasFieldModifierItemDescription = function (dictHasField) {
    return dictHasField;
};
var hasFieldModifierDescription = function (dictHasField) {
    return dictHasField;
};
var hasFieldCustomer = function (dictHasField) {
    return dictHasField;
};
var hasFieldCorrectedTotal = function (dictHasField) {
    return dictHasField;
};
var hasFieldConfirmation = function (dictHasField) {
    return dictHasField;
};
var genericSystemConfirmationStatus = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return PaymentDeclined.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return PaymentTimeout.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return PaymentAfterRestaurantClosed.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return ConfirmationTimeout.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return Invalidated.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 138, column 1 - line 138, column 103): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof PaymentDeclined) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof PaymentTimeout) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof PaymentAfterRestaurantClosed) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof ConfirmationTimeout) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof Invalidated) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 138, column 1 - line 138, column 103): " + [ x.constructor.name ]);
    }
};
var showSystemConfirmationStatus = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSystemConfirmationStatus)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "PaymentDeclined";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "PaymentTimeout";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "PaymentAfterRestaurantClosed";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ConfirmationTimeout";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Invalidated";
        }
    }))))))
};
var unscrambleDecodeSystemConfirmationStatus = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericSystemConfirmationStatus)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "PaymentDeclined";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "PaymentTimeout";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "PaymentAfterRestaurantClosed";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "ConfirmationTimeout";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Invalidated";
        }
    }))))))(Unscramble_Enum.defaultEnumOptions)
};
var genericSideInfo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showSideInfo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSideInfo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "side";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "sideGroup";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))(Data_Money_Rounded.showMoney))))({
        reflectSymbol: function () {
            return "SideInfo";
        }
    }))
};
var unscrambleDecodeSideInfo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericSideInfo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "price";
        }
    })(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "side";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "sideGroup";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var genericShortOrderId = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showShortOrderId = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericShortOrderId)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))({
        reflectSymbol: function () {
            return "ShortOrderId";
        }
    }))
};
var unscrambleDecodeShortOrderId = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericShortOrderId)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(Unscramble.decodeInt1)))(Unscramble_Generic.defaultOptions)
};
var genericProductType = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Dish.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Drink.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Pizza.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return Promotion.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return External.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 125, column 1 - line 125, column 77): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Dish) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Drink) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Pizza) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof Promotion) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof External) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 125, column 1 - line 125, column 77): " + [ x.constructor.name ]);
    }
};
var showProductType = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductType)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Dish";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Drink";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Pizza";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Promotion";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "External";
        }
    }))))))
};
var unscrambleDecodeProductType = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericProductType)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Dish";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Drink";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Pizza";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Promotion";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "External";
        }
    }))))))(Unscramble_Enum.defaultEnumOptions)
};
var genericProductPartDescription = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericPizzaPartDescription = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showPizzaPartDescription = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPizzaPartDescription)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "addedToppings";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "basePizza";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "includedToppings";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "removedToppings";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString)))(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString)))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString)))))({
        reflectSymbol: function () {
            return "PizzaPartDescription";
        }
    }))
};
var unscrambleDecodePizzaPartDescription = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPizzaPartDescription)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "addedToppings";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "basePizza";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "includedToppings";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "removedToppings";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeString1))(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var genericParameterDescription = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showParameterDescription = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericParameterDescription)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "choice";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parameter";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "ParameterDescription";
        }
    }))
};
var unscrambleDecodeParameterDescription = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericParameterDescription)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "choice";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "parameter";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var genericOrderUUID = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showOrderUUID = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericOrderUUID)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_UUID.showUUID))({
        reflectSymbol: function () {
            return "OrderUUID";
        }
    }))
};
var unscrambleDecodeOrderUUID = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericOrderUUID)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(Data_UUID.udecodeUUID)))(Unscramble_Generic.defaultOptions)
};
var genericOrderDraft = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showOrderDraft = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericOrderDraft)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Value.showValue))({
        reflectSymbol: function () {
            return "OrderDraft";
        }
    }))
};
var unscrambleDecodeOrderDraft = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericOrderDraft)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(Data_Value.udecodeValue)))(Unscramble_Generic.defaultOptions)
};
var genericModifierItemDescription = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showModifierItemDescription = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericModifierItemDescription)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "modifierItem";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "quantity";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "value";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))(Data_Show.showInt))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "ModifierItemDescription";
        }
    }))
};
var unscrambleDecodeModifierItemDescription = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericModifierItemDescription)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "modifierItem";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "quantity";
        }
    })(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "value";
        }
    })(Data_Money_Rounded.udecodeMoney)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var genericModifierDescription = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showModifierDescription = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericModifierDescription)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "addedItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "includedItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "modifier";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "removedItems";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_V2_Types_Modifier.showModifierVatRate))(Data_Money_Rounded.showMoney))(/* #__PURE__ */ Data_Show.showArray(showModifierItemDescription)))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showArray(showModifierItemDescription)))(/* #__PURE__ */ Data_Show.showArray(showModifierItemDescription)))))({
        reflectSymbol: function () {
            return "ModifierDescription";
        }
    }))
};
var showProductPartDescription = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductPartDescription)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "category";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parameters";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "product";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(Data_Money_Rounded.showMoney))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showArray(showParameterDescription)))(/* #__PURE__ */ Data_Show.showArray(showModifierDescription)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))))({
        reflectSymbol: function () {
            return "ProductPartDescription";
        }
    }))
};
var unscrambleDecodeModifierDescription = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericModifierDescription)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "addedItems";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeModifierItemDescription))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "includedItems";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeModifierItemDescription))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "modifier";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "removedItems";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeModifierItemDescription))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "value";
        }
    })(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Restaumatic_Menu_V2_Types_Modifier.unscrambleDecodeModifierVatRate)(Unscramble.decodeRecordNil))))))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeProductPartDescription = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericProductPartDescription)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "category";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeModifierDescription))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "parameters";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeParameterDescription))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "product";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "value";
        }
    })(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil))))))))))(Unscramble_Generic.defaultOptions)
};
var genericItemRole = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Main.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Side.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Freebie.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return Info.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 112, column 1 - line 112, column 71): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Main) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Side) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Freebie) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof Info) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 112, column 1 - line 112, column 71): " + [ x.constructor.name ]);
    }
};
var showItemRole = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericItemRole)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Main";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Side";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Freebie";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Info";
        }
    })))))
};
var unscrambleDecodeItemRole = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericItemRole)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Main";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Side";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Freebie";
        }
    }))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct({
        reflectSymbol: function () {
            return "Info";
        }
    })))))(Unscramble_Enum.defaultEnumOptions)
};
var genericItemDescription = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new DishDescription(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new SideDescription(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new DrinkDescription(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new PizzaDescription(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new FreebieDescription(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new TextDescription(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return new SplitPizzaDescription(x.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return new ProductDescription(x.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))) {
            return NoDescription.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 99, column 1 - line 99, column 85): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof DishDescription) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof SideDescription) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof DrinkDescription) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof PizzaDescription) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof FreebieDescription) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof TextDescription) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof SplitPizzaDescription) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))));
        };
        if (x instanceof ProductDescription) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
        };
        if (x instanceof NoDescription) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 99, column 1 - line 99, column 85): " + [ x.constructor.name ]);
    }
};
var showItemDescription = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericItemDescription)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "basePrice";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "dishGroup";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "sides";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(/* #__PURE__ */ Data_Show.showArray(showSideInfo)))(Data_Show.showString))(Data_Money_Rounded.showMoney))))({
        reflectSymbol: function () {
            return "DishDescription";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "sideGroup";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))))({
        reflectSymbol: function () {
            return "SideDescription";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "drinkSize";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "DrinkDescription";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "addedToppings";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "includedToppings";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "pizzaSize";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "removedToppings";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString)))(Data_Show.showString))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString)))(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString)))))({
        reflectSymbol: function () {
            return "PizzaDescription";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "freebie";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "FreebieDescription";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "TextDescription";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "pizzaSize";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showArray(showPizzaPartDescription)))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "SplitPizzaDescription";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parameters";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "productParts";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(/* #__PURE__ */ Data_Show.showArray(showProductPartDescription)))(/* #__PURE__ */ Data_Show.showArray(showParameterDescription)))(/* #__PURE__ */ Data_Show.showArray(showModifierDescription)))))({
        reflectSymbol: function () {
            return "ProductDescription";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "NoDescription";
        }
    }))))))))))
};
var unscrambleDecodeItemDescription = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericItemDescription)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "DishDescription";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "basePrice";
        }
    })(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "dishGroup";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "sides";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeSideInfo))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "SideDescription";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "sideGroup";
        }
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "DrinkDescription";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "drinkSize";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "PizzaDescription";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "addedToppings";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "includedToppings";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "panType";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "pizzaSize";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "removedToppings";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "FreebieDescription";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "freebie";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "TextDescription";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "description";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "SplitPizzaDescription";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "panType";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodePizzaPartDescription))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "pizzaSize";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ProductDescription";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeModifierDescription))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "parameters";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeParameterDescription))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "productParts";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeProductPartDescription))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "NoDescription";
        }
    })))))))))))(Unscramble_Generic.defaultOptions)
};
var genericIntegrationId = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showIntegrationId = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericIntegrationId)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showInt))({
        reflectSymbol: function () {
            return "IntegrationId";
        }
    }))
};
var unscrambleDecodeIntegrationId = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericIntegrationId)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(Unscramble.decodeInt1)))(Unscramble_Generic.defaultOptions)
};
var genericCustomer = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCustomer = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCustomer)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "email";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "originalPhone";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "phone";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))))({
        reflectSymbol: function () {
            return "Customer";
        }
    }))
};
var unscrambleDecodeCustomer = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCustomer)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "email";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "originalPhone";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "phone";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var genericCorrectedTotal = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCorrectedTotal = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCorrectedTotal)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "reason";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "total";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "CorrectedTotal";
        }
    }))
};
var unscrambleDecodeCorrectedTotal = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCorrectedTotal)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "reason";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "total";
        }
    })(Data_Money_Rounded.udecodeMoney)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var genericConfirmationStatus = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Accepted(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return Rejected.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 53, column 1 - line 53, column 91): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Accepted) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Rejected) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 53, column 1 - line 53, column 91): " + [ x.constructor.name ]);
    }
};
var showConfirmationStatus = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericConfirmationStatus)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "deliveryTime";
        }
    })(Data_Show.showRecordFieldsNil)(Data_UTCTime.showUTCTime))))({
        reflectSymbol: function () {
            return "Accepted";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Rejected";
        }
    })))
};
var unscrambleDecodeConfirmationStatus = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericConfirmationStatus)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Accepted";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "deliveryTime";
        }
    })(Data_UTCTime.unscrambleDecodeUTCTime)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Rejected";
        }
    }))))(Unscramble_Generic.defaultOptions)
};
var genericConfirmationSource = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return AutoCancel.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new PR(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new ROS(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return Email.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new CallCenter(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return Printer.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))) {
            return Pendolino.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))) {
            return new System(x.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))) {
            return new APIIntegration(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))) {
            return PosBistro.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))))))))) {
            return AutoCallCenter.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))))))))) {
            return Portal.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))))))))) {
            return Unknown.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 38, column 1 - line 38, column 91): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AutoCancel) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof PR) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof ROS) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof Email) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof CallCenter) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof Printer) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))));
        };
        if (x instanceof Pendolino) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))));
        };
        if (x instanceof System) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))))));
        };
        if (x instanceof APIIntegration) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))))))));
        };
        if (x instanceof PosBistro) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))));
        };
        if (x instanceof AutoCallCenter) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)))))))))));
        };
        if (x instanceof Portal) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))))))))))));
        };
        if (x instanceof Unknown) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))))))))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.Types (line 38, column 1 - line 38, column 91): " + [ x.constructor.name ]);
    }
};
var showConfirmationSource = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericConfirmationSource)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "AutoCancel";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "staffId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "staffName";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Restaumatic_Staff_Types_Id.showStaffId))))({
        reflectSymbol: function () {
            return "PR";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "staffId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "staffName";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "terminalId";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_ROS_Types_TerminalId.showTerminalId)))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Restaumatic_Staff_Types_Id.showStaffId))))({
        reflectSymbol: function () {
            return "ROS";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Email";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "adminUserId";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Backstage_Types_Id.showAdminUserId))))({
        reflectSymbol: function () {
            return "CallCenter";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Printer";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Pendolino";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "status";
        }
    })(Data_Show.showRecordFieldsNil)(showSystemConfirmationStatus))))({
        reflectSymbol: function () {
            return "System";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "integration";
        }
    })(Data_Show.showRecordFieldsNil)(showIntegrationId))))({
        reflectSymbol: function () {
            return "APIIntegration";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "PosBistro";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "AutoCallCenter";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Portal";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "Unknown";
        }
    }))))))))))))))
};
var unscrambleDecodeConfirmationSource = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericConfirmationSource)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "AutoCancel";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "PR";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "staffId";
        }
    })(Restaumatic_Staff_Types_Id.udecodeStaffId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "staffName";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ROS";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "staffId";
        }
    })(Restaumatic_Staff_Types_Id.udecodeStaffId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "staffName";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "terminalId";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_ROS_Types_TerminalId.udecodeTerminalId))(Unscramble.decodeRecordNil))))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Email";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "CallCenter";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "adminUserId";
        }
    })(Restaumatic_Backstage_Types_Id.udecodeAdminUserId)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Printer";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Pendolino";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "System";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "status";
        }
    })(unscrambleDecodeSystemConfirmationStatus)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "APIIntegration";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "integration";
        }
    })(unscrambleDecodeIntegrationId)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "PosBistro";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "AutoCallCenter";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Portal";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "Unknown";
        }
    })))))))))))))))(Unscramble_Generic.defaultOptions)
};
var genericConfirmation = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showConfirmation = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericConfirmation)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "confirmedAt";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "message";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "status";
        }
    })(Data_Show.showRecordFieldsNil)(showConfirmationStatus))(showConfirmationSource))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Data_UTCTime.showUTCTime))))({
        reflectSymbol: function () {
            return "Confirmation";
        }
    }))
};
var unscrambleDecodeConfirmation = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericConfirmation)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "confirmedAt";
        }
    })(Data_UTCTime.unscrambleDecodeUTCTime)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "message";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "source";
        }
    })(unscrambleDecodeConfirmationSource)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "status";
        }
    })(unscrambleDecodeConfirmationStatus)(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeSystemConfirmationStatus = {
    encode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericEncodeEnum(genericSystemConfirmationStatus)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "PaymentDeclined";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "PaymentTimeout";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "PaymentAfterRestaurantClosed";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "ConfirmationTimeout";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Invalidated";
        }
    }))))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var encodeSideInfo = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericSideInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "SideInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "sideGroup";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "side";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney))))))(encodingOpts)
};
var encodeShortOrderId = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericShortOrderId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ShortOrderId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))(encodingOpts)
};
var encodeProductType = {
    encode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericEncodeEnum(genericProductType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Dish";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Drink";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Pizza";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Promotion";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "External";
        }
    }))))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var encodePizzaPartDescription = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericPizzaPartDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PizzaPartDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "removedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "includedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "basePizza";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "addedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode)))))))(encodingOpts)
};
var encodeParameterDescription = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericParameterDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ParameterDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "parameter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "choice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var encodeOrderUUID = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericOrderUUID)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "OrderUUID";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_UUID.encodeUUID))))(encodingOpts)
};
var encodeOrderDraft = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericOrderDraft)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "OrderDraft";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Value.encodeValue))))(encodingOpts)
};
var encodeModifierItemDescription = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericModifierItemDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ModifierItemDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "quantity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
        reflectSymbol: function () {
            return "modifierItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var encodeModifierDescription = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericModifierDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ModifierDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Modifier.encodeModifierVatRate)))({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "removedItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeModifierItemDescription))))({
        reflectSymbol: function () {
            return "modifier";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "includedItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeModifierItemDescription))))({
        reflectSymbol: function () {
            return "addedItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeModifierItemDescription)))))))(encodingOpts)
};
var encodeProductPartDescription = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericProductPartDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductPartDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "product";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "parameters";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeParameterDescription))))({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeModifierDescription))))({
        reflectSymbol: function () {
            return "category";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))))))(encodingOpts)
};
var encodeItemRole = {
    encode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericEncodeEnum(genericItemRole)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Main";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Side";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Freebie";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum({
        reflectSymbol: function () {
            return "Info";
        }
    })))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var encodeItemDescription = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericItemDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "DishDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "sides";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeSideInfo))))({
        reflectSymbol: function () {
            return "dishGroup";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "basePrice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "SideDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "sideGroup";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "DrinkDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "drinkSize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PizzaDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "removedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "pizzaSize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "includedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "addedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode)))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "FreebieDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "freebie";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "TextDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "SplitPizzaDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "pizzaSize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodePizzaPartDescription))))({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "productParts";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeProductPartDescription))))({
        reflectSymbol: function () {
            return "parameters";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeParameterDescription))))({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeModifierDescription)))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "NoDescription";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))))))))))(encodingOpts)
};
var encodeIntegrationId = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericIntegrationId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "IntegrationId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))(encodingOpts)
};
var encodeCustomer = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericCustomer)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Customer";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "phone";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "originalPhone";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "email";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode)))))))(encodingOpts)
};
var encodeCorrectedTotal = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericCorrectedTotal)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CorrectedTotal";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "total";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "reason";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(encodingOpts)
};
var encodeConfirmationStatus = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericConfirmationStatus)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Accepted";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "deliveryTime";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_UTCTime.encodeUTCTime))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Rejected";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))(encodingOpts)
};
var encodeConfirmationSource = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericConfirmationSource)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "AutoCancel";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PR";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "staffName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "staffId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Staff_Types_Id.encodeStaffId))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ROS";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "terminalId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_ROS_Types_TerminalId.encodeTerminalId))))({
        reflectSymbol: function () {
            return "staffName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "staffId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Staff_Types_Id.encodeStaffId))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Email";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CallCenter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "adminUserId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Backstage_Types_Id.encodeAdminUserId))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Printer";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Pendolino";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "System";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "status";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeSystemConfirmationStatus))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "APIIntegration";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "integration";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeIntegrationId))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "PosBistro";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "AutoCallCenter";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Portal";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Unknown";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))))))))))))))(encodingOpts)
};
var encodeConfirmation = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericConfirmation)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Confirmation";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "status";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeConfirmationStatus)))({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeConfirmationSource)))({
        reflectSymbol: function () {
            return "message";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "confirmedAt";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_UTCTime.encodeUTCTime))))))(encodingOpts)
};
var decodeSystemConfirmationStatus = {
    decode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericDecodeEnum(genericSystemConfirmationStatus)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "PaymentDeclined";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "PaymentTimeout";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "PaymentAfterRestaurantClosed";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "ConfirmationTimeout";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Invalidated";
        }
    }))))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var decodeSideInfo = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericSideInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "SideInfo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "sideGroup";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "side";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeShortOrderId = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericShortOrderId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ShortOrderId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeProductType = {
    decode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericDecodeEnum(genericProductType)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Dish";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Drink";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Pizza";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Promotion";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "External";
        }
    }))))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var decodePizzaPartDescription = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericPizzaPartDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PizzaPartDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "removedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "includedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "basePizza";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "addedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeParameterDescription = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericParameterDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ParameterDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "parameter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "choice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeOrderUUID = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericOrderUUID)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "OrderUUID";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_UUID.decodeUUID)))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeOrderDraft = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericOrderDraft)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "OrderDraft";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Value.decodeValue)))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeModifierItemDescription = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericModifierItemDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ModifierItemDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "quantity";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
        reflectSymbol: function () {
            return "modifierItem";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeModifierDescription = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericModifierDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ModifierDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Modifier.decodeModifierVatRate))())({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "removedItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeModifierItemDescription)))())({
        reflectSymbol: function () {
            return "modifier";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "includedItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeModifierItemDescription)))())({
        reflectSymbol: function () {
            return "addedItems";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeModifierItemDescription)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeProductPartDescription = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericProductPartDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductPartDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "value";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "product";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "parameters";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeParameterDescription)))())({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeModifierDescription)))())({
        reflectSymbol: function () {
            return "category";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeItemRole = {
    decode: /* #__PURE__ */ Foreign_Generic_EnumEncoding.genericDecodeEnum(genericItemRole)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Main";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Side";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Freebie";
        }
    }))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum({
        reflectSymbol: function () {
            return "Info";
        }
    })))))(Foreign_Generic_EnumEncoding.defaultGenericEnumOptions)
};
var decodeItemDescription = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericItemDescription)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "DishDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "sides";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeSideInfo)))())({
        reflectSymbol: function () {
            return "dishGroup";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "basePrice";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "SideDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "sideGroup";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "DrinkDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "drinkSize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PizzaDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "removedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "pizzaSize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "includedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "addedToppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "FreebieDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "freebie";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "TextDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "SplitPizzaDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "pizzaSize";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodePizzaPartDescription)))())({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
        reflectSymbol: function () {
            return "productParts";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeProductPartDescription)))())({
        reflectSymbol: function () {
            return "parameters";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeParameterDescription)))())({
        reflectSymbol: function () {
            return "modifiers";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeModifierDescription)))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "NoDescription";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))))))))))(encodingOpts)
};
var decodeIntegrationId = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericIntegrationId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "IntegrationId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode)))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeCustomer = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericCustomer)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Customer";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "phone";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "originalPhone";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "email";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeCorrectedTotal = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericCorrectedTotal)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CorrectedTotal";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "total";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
        reflectSymbol: function () {
            return "reason";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeConfirmationStatus = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericConfirmationStatus)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Accepted";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "deliveryTime";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_UTCTime.decodeUTCTime))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Rejected";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments)))(encodingOpts)
};
var decodeConfirmationSource = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericConfirmationSource)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "AutoCancel";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PR";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "staffName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "staffId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Staff_Types_Id.decodeStaffId))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ROS";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "terminalId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_ROS_Types_TerminalId.decodeTerminalId)))())({
        reflectSymbol: function () {
            return "staffName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "staffId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Staff_Types_Id.decodeStaffId))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Email";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "CallCenter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "adminUserId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Backstage_Types_Id.decodeAdminUserId))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Printer";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Pendolino";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "System";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "status";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeSystemConfirmationStatus))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "APIIntegration";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "integration";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeIntegrationId))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "PosBistro";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "AutoCallCenter";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Portal";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Unknown";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))))))))))))))(encodingOpts)
};
var decodeConfirmation = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericConfirmation)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Confirmation";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "status";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeConfirmationStatus))())({
        reflectSymbol: function () {
            return "source";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeConfirmationSource))())({
        reflectSymbol: function () {
            return "message";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "confirmedAt";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_UTCTime.decodeUTCTime))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    AutoCancel,
    PR,
    ROS,
    Email,
    CallCenter,
    Printer,
    Pendolino,
    System,
    APIIntegration,
    PosBistro,
    AutoCallCenter,
    Portal,
    Unknown,
    Accepted,
    Rejected,
    DishDescription,
    SideDescription,
    DrinkDescription,
    PizzaDescription,
    FreebieDescription,
    TextDescription,
    SplitPizzaDescription,
    ProductDescription,
    NoDescription,
    Main,
    Side,
    Freebie,
    Info,
    Dish,
    Drink,
    Pizza,
    Promotion,
    External,
    PaymentDeclined,
    PaymentTimeout,
    PaymentAfterRestaurantClosed,
    ConfirmationTimeout,
    Invalidated,
    Confirmation,
    CorrectedTotal,
    Customer,
    IntegrationId,
    ModifierDescription,
    ModifierItemDescription,
    OrderDraft,
    OrderUUID,
    ParameterDescription,
    PizzaPartDescription,
    ProductPartDescription,
    ShortOrderId,
    SideInfo,
    encodingOpts,
    genericConfirmationSource,
    showConfirmationSource,
    eqConfirmationSource,
    decodeConfirmationSource,
    unscrambleDecodeConfirmationSource,
    encodeConfirmationSource,
    genericConfirmationStatus,
    showConfirmationStatus,
    eqConfirmationStatus,
    decodeConfirmationStatus,
    unscrambleDecodeConfirmationStatus,
    encodeConfirmationStatus,
    genericItemDescription,
    showItemDescription,
    eqItemDescription,
    decodeItemDescription,
    unscrambleDecodeItemDescription,
    encodeItemDescription,
    genericItemRole,
    showItemRole,
    eqItemRole,
    decodeItemRole,
    unscrambleDecodeItemRole,
    encodeItemRole,
    genericProductType,
    showProductType,
    eqProductType,
    decodeProductType,
    unscrambleDecodeProductType,
    encodeProductType,
    genericSystemConfirmationStatus,
    showSystemConfirmationStatus,
    eqSystemConfirmationStatu,
    decodeSystemConfirmationStatus,
    unscrambleDecodeSystemConfirmationStatus,
    encodeSystemConfirmationStatus,
    genericConfirmation,
    showConfirmation,
    eqConfirmation,
    decodeConfirmation,
    unscrambleDecodeConfirmation,
    encodeConfirmation,
    newtypeConfirmation,
    hasFieldConfirmation,
    genericCorrectedTotal,
    showCorrectedTotal,
    eqCorrectedTotal,
    decodeCorrectedTotal,
    unscrambleDecodeCorrectedTotal,
    encodeCorrectedTotal,
    newtypeCorrectedTotal,
    hasFieldCorrectedTotal,
    genericCustomer,
    showCustomer,
    eqCustomer,
    decodeCustomer,
    unscrambleDecodeCustomer,
    encodeCustomer,
    newtypeCustomer,
    hasFieldCustomer,
    genericIntegrationId,
    showIntegrationId,
    eqIntegrationId,
    decodeIntegrationId,
    unscrambleDecodeIntegrationId,
    encodeIntegrationId,
    newtypeIntegrationId,
    genericModifierDescription,
    showModifierDescription,
    eqModifierDescription,
    decodeModifierDescription,
    unscrambleDecodeModifierDescription,
    encodeModifierDescription,
    newtypeModifierDescription,
    hasFieldModifierDescription,
    genericModifierItemDescription,
    showModifierItemDescription,
    eqModifierItemDescription,
    decodeModifierItemDescription,
    unscrambleDecodeModifierItemDescription,
    encodeModifierItemDescription,
    newtypeModifierItemDescription,
    hasFieldModifierItemDescription,
    genericOrderDraft,
    showOrderDraft,
    eqOrderDraft,
    decodeOrderDraft,
    unscrambleDecodeOrderDraft,
    encodeOrderDraft,
    newtypeOrderDraft,
    genericOrderUUID,
    showOrderUUID,
    eqOrderUUID,
    decodeOrderUUID,
    unscrambleDecodeOrderUUID,
    encodeOrderUUID,
    newtypeOrderUUID,
    genericParameterDescription,
    showParameterDescription,
    eqParameterDescription,
    decodeParameterDescription,
    unscrambleDecodeParameterDescription,
    encodeParameterDescription,
    newtypeParameterDescription,
    hasFieldParameterDescription,
    genericPizzaPartDescription,
    showPizzaPartDescription,
    eqPizzaPartDescription,
    decodePizzaPartDescription,
    unscrambleDecodePizzaPartDescription,
    encodePizzaPartDescription,
    newtypePizzaPartDescription,
    hasFieldPizzaPartDescription,
    genericProductPartDescription,
    showProductPartDescription,
    eqProductPartDescription,
    decodeProductPartDescription,
    unscrambleDecodeProductPartDescription,
    encodeProductPartDescription,
    newtypeProductPartDescription,
    hasFieldProductPartDescription,
    genericShortOrderId,
    showShortOrderId,
    eqShortOrderId,
    decodeShortOrderId,
    unscrambleDecodeShortOrderId,
    encodeShortOrderId,
    newtypeShortOrderId,
    genericSideInfo,
    showSideInfo,
    eqSideInfo,
    decodeSideInfo,
    unscrambleDecodeSideInfo,
    encodeSideInfo,
    newtypeSideInfo,
    hasFieldSideInfo
};
//# sourceMappingURL=index.js.map
